import { Injectable } from '@angular/core';
import { ModuleValues } from '@type/module.type';
import { ConfirmationService } from 'primeng/api';

@Injectable({
  providedIn: 'root',
})
export class AppService {
  currentModule: ModuleValues;

  constructor(
    private confirmationService: ConfirmationService,
  ) { }

  confirm(
    accept: () => void,
    config?: { message?: string, severity?: 'DANGER' | 'NORMAL'},
  ): void {
    this.confirmationService.confirm({
      header: config?.severity === 'DANGER' ? 'Warning' : 'Confirmation',
      message: config?.message ?? 'Are you sure that you want to proceed?',
      rejectButtonProps: {
        label: 'No',
        severity: 'secondary',
      },
      acceptButtonProps: {
        label: 'Yes',
        severity: config?.severity?.toLowerCase() ?? 'normal',
      },
      accept,
    });
  }
}
